import { render, staticRenderFns } from "./OwnerResum.vue?vue&type=template&id=c3775672&"
import script from "./OwnerResum.vue?vue&type=script&lang=js&"
export * from "./OwnerResum.vue?vue&type=script&lang=js&"
import style0 from "./OwnerResum.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports